// extracted by mini-css-extract-plugin
export var pageWrap = "screver-btq-module--pageWrap--sspVK";